(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueuesDeleteController',QueuesDeleteController);

    QueuesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueuesDeleteController($uibModalInstance, entity, Queue) {
        var vm = this;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queues = entity;
                if (vm.queues.licenseExpirationDate != null) {
                    vm.queues.licenseExpirationDate = new Date(vm.queues.licenseExpirationDate);
                }
            });
        }

        vm.queues;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            Queue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
